var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 6.33984H10.0007V2.33984H6.00065V6.33984H3.33398L8.00065 11.0065L12.6673 6.33984ZM7.33398 7.67318V3.67318H8.66732V7.67318H9.44732L8.00065 9.11984L6.55398 7.67318H7.33398ZM3.33398 12.3398H12.6673V13.6732H3.33398V12.3398Z",
    fill: "#376FD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlueIcon);
export default __webpack_public_path__ + "static/media/download-blue-icon.2b7cbcae.svg";
export { ForwardRef as ReactComponent };